import React, { useEffect } from 'react';
import { Card, CardContent, Typography, Button, Grid, Divider, Box } from '@mui/material';
import UserHeader from '../UserComponent/UserHeader';
import payment_icon from "../../images/payment_icon.png";
import payCallIcon from "../../images/payCallIcon.png";
import payEmailIcon from "../../images/payEmailIcon.png";
import { useLocation, useNavigate } from 'react-router-dom';

export const Success = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { package: selectedPackage, payment_id } = location.state || {};
    const email = localStorage.getItem('email');
    const currentDateTime = new Date().toLocaleString('en-GB', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric', 
        hour: '2-digit', 
        minute: '2-digit', 
        hour12: true 
    });
    
    React.useEffect(() => {
        if (!selectedPackage || !payment_id ) {
            navigate('/upgrade')
        }
    }, [navigate, selectedPackage, payment_id]);
    
    return (
        <div>
            <UserHeader />
            <div className="container">
                <div className='siteForm'>
                <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                    <Grid item lg={6} md={8} sm={10} xs={12}>
                        <Card elevation={4} sx={{ p: 4 }}>
                            <CardContent>
                                <Box textAlign="center" mb={3}>
                                    <img src={payment_icon} alt="Payment Icon" style={{ maxWidth: '100px', marginBottom: '20px' }} />
                                    <Typography variant="h4" gutterBottom className='orderTitlet'>
                                        Order Placed Successfully!
                                    </Typography>
                                    <Typography variant="subtitle1" color="textSecondary" className='paymentID'>
                                         Payment ID: {payment_id}, {currentDateTime}
                                    </Typography>
                                </Box>

                                <Divider sx={{ my: 3 }} />

                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    <Typography variant="h5" className="planTxt">{selectedPackage.package_name} Plan for {selectedPackage.valid_period} Months</Typography>
                                    <Typography variant="h5" className="planTxt">₹ {selectedPackage.package_price}</Typography>
                                </Box>
                                {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography variant="h6"  className="planTxtYellow">GST 12%</Typography>
                                    <Typography variant="h6" className="planTxtYellow">₹ 360</Typography>
                                </Box> */}
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="h6" className="planTxtYellow">Total Price</Typography>
                                    <Typography variant="h6" className="planTxtYellow">₹ {selectedPackage.package_price}</Typography>
                                </Box>

                                <Divider sx={{ my: 3 }} />
                                <div className="mt-3">
                                <Typography variant="body1" textAlign="center" mb={2} className='packTxt'>
                                    Your packages will be activated shortly.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" textAlign="center" className='payMesg mt-2'>
                                    We will send an invoice with your order details within 24 hours to your registered email:
                                </Typography>
                                <Typography variant="body2" textAlign="center" sx={{ fontWeight: 'bold', mt: 1 }}>
                                    {email}
                                </Typography>
                                </div>

                                <Divider sx={{ my: 3 }} />

                                <Typography variant="h6" textAlign="center" className='queriesTxt'>
                                    For any further queries
                                </Typography>
                                <Box display="flex" justifyContent="center" gap={3} mt={1}>
                                    <Typography variant="body1">
                                        <img src={payCallIcon} alt="Phone Icon" style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                                        +918600555740
                                    </Typography>
                                    <Typography variant="body1">
                                        <img src={payEmailIcon} alt="Email Icon" style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                                        support@indmatrimony.in
                                    </Typography>
                                </Box>

                                <Box textAlign="center" mt={4}>
                                    <Button variant="contained" color="primary" href="/" size="large">
                                        Go To My Dashboard
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
            </div>
        </div>
    );
}
